import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import parser from 'html-react-parser';

const CookiePolicyContent = () => {
  const { t } = useLanguage();

  // Map section IDs to translation keys
  const sections = [
    { id: 'introduction', key: 'cookies.policy.sections.introduction' },
    { id: 'categories', key: 'cookies.policy.sections.categories' },
    { id: 'cookies-we-use', key: 'cookies.policy.sections.cookiesWeUse' },
    { id: 'google-analytics', key: 'cookies.policy.sections.googleAnalytics' },
    { id: 'your-choices', key: 'cookies.policy.sections.yourChoices' },
    { id: 'contact', key: 'cookies.policy.sections.contact' },
  ];

  return (
    <div className="st-cookie-policy-content">
      <h1 className="st-cookie-policy-title">{t('cookies.policy.title')}</h1>
      <p className="st-cookie-policy-updated">
        <strong>{t('cookies.policy.lastUpdatedLabel')}:</strong> {t('cookies.policy.lastUpdated')}
      </p>

      {sections.map((section) => (
        <section key={section.id} id={section.id} className="st-cookie-policy-section">
          <h2 className="st-cookie-policy-section-title">
            {t(`${section.key}.title`)}
          </h2>
          <div className="st-cookie-policy-section-content">
            {parser(t(`${section.key}.content`))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default CookiePolicyContent;
